module.exports = __webpack_public_path__ + "img/epos3.0b9368b5.jpg";